import {Injectable} from '@angular/core';
import {ApiService} from "@biletix/core/services/api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiResponse} from "@biletix/core/models/api-response";
import {map} from "rxjs/operators";
import {Country} from "@biletix/core/models/country.model";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private basePath: string = "/api/v1/bxcached/country";

  constructor(private apiService: ApiService,
              private http: HttpClient) {
  }

  public getAllCountry(): Observable<Country[]> {
    return this.http.get<ApiResponse<Country[]>>(//
      `${this.apiService.getCrmApiHost()}${this.basePath}/all`)
      .pipe(map(response => response.data));
  }
}
